import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {Router, RouterLink} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {Roles} from '@services/models/roles.enum';
import {LogginedUser} from '@services/models/user.model';
import {AuthService} from "@shared/services/security/auth.service";
import {BreadcrumbService} from "@cdss/services/breadcrumb.service";
import {BreadcrumbItem} from "@cdss/services/breadcrumb-item.value";


export const userMetaData = {
    [Roles.Admin]: {
        role: 'Admin',
        icon: 'assets/images/avatar-admin.png'
    },
    [Roles.StudyManager]: {
        role: 'Clinician',
        icon: 'assets/images/avatar.png'
    }
}

@Component({
    selector: 'cdss-header',
    imports: [RouterLink],
    providers: [],
    templateUrl: './cdss-header.component.html',
    standalone: true,
    styleUrl: './cdss-header.component.scss'
})
export class CdssHeaderComponent implements OnInit {

    user: LogginedUser;
    breadcrumb: BreadcrumbItem[]

    constructor(
        private authService: AuthService,
        private router: Router,
        private toastr: ToastrService,
        private breadcrumbService: BreadcrumbService,
        private cdr: ChangeDetectorRef
    ) {
    }

    ngOnInit() {
        this.getLoginedUser();
        this.authService.loggedUser$.subscribe((user: LogginedUser) => {
            this.user = user
        })
        this.breadcrumbService.content$.subscribe(
            content => {
                this.breadcrumb = content
                this.cdr.detectChanges()
            });
    }

    private getLoginedUser() {
        this.authService.getLogginedUser()
            .subscribe((user: LogginedUser) => {
                this.user = user;
            });
    }

    get avatar() {
        return this.user ? userMetaData[this.user.roleName] : null;
    }

    logOut() {

        this.authService.signOut().subscribe(
            (res: any) => {
                // Handle successful sign-in (redirect, show message, etc.)
                if (res) {
                    this.toastr.success(res.message, 'Sign out Successfully');
                }
            },
            error => {
                this.toastr.error(error.error.message, ' ');
                this.router.navigate(['/signin']);
                // this.toastr.error(error.error.message,' '); // Assuming API returns error message
                console.error('Sign in error:', error);
            }
        );
    }
}
